// src/screens/DataDeletionScreen/components/DataDeletionConfirm/index.ts
import { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useConfirmDataDeletionRequest } from 'customHooks/useConfirmDataDeletionRequest';
import { DataDeletionConfirmContainer } from './style';
import hotelLogoBig from 'assets/images/rook-logo-big.svg';

const DataDeletionConfirm: FC = () => {
  const location = useLocation();

  const [confirmed, setConfirmed] = useState(false);
  const [failed, setFailed] = useState(false);

  const { confirmDataDeletionRequest, loading } = useConfirmDataDeletionRequest();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (!token) {
      setFailed(true);
      return;
    }

    const confirm = async () => {
      const ok = await confirmDataDeletionRequest(token);

      if (ok) {
        setConfirmed(true);
      } else {
        setFailed(true);
      }
    };

    confirm();
  }, [location.search, confirmDataDeletionRequest]);

  return (
    
      <DataDeletionConfirmContainer>
        <div className="content">
        <img
            src={hotelLogoBig}
            alt="Rook Hotel"
            className="hotelLogoBig"
          />

          {loading && <h2>Confirming your request...</h2>}

          {!loading && confirmed && (
            <>
              <h2>Thank you for confirming your request.</h2>
              <p>
                Your deletion request has been received and will be processed
                within the next 24 hours.
              </p>
              <p>
                If you have any questions, please{' '}
                <a href="/contact-us">contact our support team.</a>
              </p>
            </>
          )}

          {!loading && failed && (
            <>
              <h2>We could not confirm your request.</h2>
              <p>
                The confirmation link is invalid or has expired.<br /><br /> Please submit a
                new deletion request or <a href="/contact-us">contact our support team.</a>
              </p>
            </>
          )}
        </div>
      </DataDeletionConfirmContainer>

  );
};

export default DataDeletionConfirm;